/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Weight_Management_TermsInputs */

const en_service_type_weight_management_terms = /** @type {(inputs: Service_Type_Weight_Management_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weight loss, lose weight, overweight, obesity, fat loss`)
};

const pl_service_type_weight_management_terms = /** @type {(inputs: Service_Type_Weight_Management_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`redukcja, odchudzanie, utrata wagi, nadwaga, otyłość, schudnąć`)
};

/**
* | output |
* | --- |
* | "weight loss, lose weight, overweight, obesity, fat loss" |
*
* @param {Service_Type_Weight_Management_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_weight_management_terms = /** @type {((inputs?: Service_Type_Weight_Management_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Weight_Management_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_weight_management_terms(inputs)
	return en_service_type_weight_management_terms(inputs)
});